<template>
    <div>
        <el-container style="border: 1px solid #eee">
            <el-aside width="200" >
                <el-menu :collapse="isCollapsed">
                    <el-menu-item >
                        <img src="../../assets/images/AuthPageLogo.png"/>
                        <button @click="toggleCollapse()">
                            <app-exchange-icon/>
                        </button>
                    </el-menu-item>
                    <el-menu-item @click="goToPage('dashboard-profile')">
                        <app-male-person-icon/>
                        <span slot="title">پروفایل</span>
<!--                        پروفایل-->
                    </el-menu-item>
                    <el-menu-item @click="goToPage('dashboard-writing')">
                        <app-writing-icon/>
                        <span slot="title">ارسال مطلب</span>
<!--                        ارسال مطلب-->
                    </el-menu-item>
                    <el-menu-item @click="goToPage('dashboard-user-writings')">
                        <app-stack-papers-icon/>
                        <span slot="title">مطالب ارسال شده</span>
                    </el-menu-item>
                    <el-menu-item
                        @click="goToPage('dashboard-users')"
                        v-if="user !== undefined && user.role !== undefined && (user.role === 'admin' || user.role === 'creator')">
                        <app-multiple-persons-icon/>
                        <span slot="title">کاربران</span>
<!--                        کاربران-->
                    </el-menu-item>
                    <el-menu-item @click="signOut">
                        <app-sing-out-icon/>
                        <span slot="title">خروج</span>
<!--                        خروج-->
                    </el-menu-item>
<!--                    <el-submenu index="1">-->
<!--                        <template slot="title"><i class="el-icon-message"></i>Navigator One</template>-->
<!--                        <el-menu-item-group>-->
<!--                            <template slot="title">Group 1</template>-->
<!--                            <el-menu-item index="1-1">Option 1</el-menu-item>-->
<!--                            <el-menu-item index="1-2">Option 2</el-menu-item>-->
<!--                        </el-menu-item-group>-->
<!--                        <el-menu-item-group title="Group 2">-->
<!--                            <el-menu-item index="1-3">Option 3</el-menu-item>-->
<!--                        </el-menu-item-group>-->
<!--                        <el-submenu index="1-4">-->
<!--                            <template slot="title">Option4</template>-->
<!--                            <el-menu-item index="1-4-1">Option 4-1</el-menu-item>-->
<!--                        </el-submenu>-->
<!--                    </el-submenu>-->
                </el-menu>
            </el-aside>
            <el-container class="router-container">
                <router-view></router-view>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'Dashboard',
        data() {
            return {
                isCollapsed: false,
                user: {}
            }
        },
        created() {
            this.user = JSON.parse(localStorage.getItem('auth')).user;
        },
        methods: {
            goToPage(routeName) {
                this.$router.push({name: routeName});
            },
            signOut() {
                // localStorage.clear();
                this.$http.post(
                    `${this.apiURL}/user/signout`,
                    { refreshToken: JSON.parse(localStorage.getItem('auth')).refreshToken }
                ).then(
                    (response) => {
                        localStorage.removeItem('auth');
                        this.$router.push({name: 'home'});
                    }
                ).catch((err) => {});
            },
            toggleCollapse() {
                this.isCollapsed = !this.isCollapsed;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-container {
        direction: rtl;
        text-align: right;
        width: 100%;
        height: 100%;
        min-height: 99vh;

        .el-aside {
            background-color: #30426A;
            border-left: 1px solid #BBBBBB;

             .el-menu::v-deep {
                width: 200px;
                padding-right: 0;
                color: white;
                background-color: transparent;

                 .el-menu-item {
                    color: #B2BFDC;
                    border-bottom: 1px solid #BBBBBB;
                    text-indent: 5px;

                     svg {
                         margin-left: 10px;
                     }

                    &:hover, &:focus {
                        color: white;
                        background-color: #2D3E63;
                        border-right: 4px solid #e99d1a;
                        text-indent: 1px;
                    }

                    &:first-child {
                        height: 70px;

                        &:hover, &:focus {
                            color: #B2BFDC;
                            background-color: transparent;
                            border-right: none;
                            text-indent: 5px;
                        }

                        img {
                            width: 100px;
                        }

                        button {
                            position: absolute;
                            left: 6%;
                            top: 22%;
                            background-color: transparent;
                            color: currentColor;
                            padding: 0;
                            border: none;
                            outline: none;
                            cursor: pointer;
                            transition: .4s all ease;

                            svg {
                                height: 35px;
                            }

                            &:hover {
                                color: white;
                            }
                        }
                    }

                }

                .el-submenu {

                    .el-submenu__title {
                        color: currentColor;

                        .el-submenu__icon-arrow {
                            right: unset;
                            left: 20px !important;
                        }
                    }

                }

                 &.el-menu--collapse {
                     width: 64px;

                     .el-menu-item {

                         &:first-child {
                             padding: 0 10px !important;

                             button {
                                 position: relative;
                                 top: unset;
                                 left: unset;
                                 vertical-align: sub;
                             }
                             img {
                                 display: none;
                             }
                         }

                     }
                 }
            }
        }

        .el-container.router-container {
            padding: 15px;
        }
    }

</style>
